import { render } from "./UpdatePrimaryStorage.vue?vue&type=template&id=5db647f4&scoped=true"
import script from "./UpdatePrimaryStorage.vue?vue&type=script&lang=js"
export * from "./UpdatePrimaryStorage.vue?vue&type=script&lang=js"

import "./UpdatePrimaryStorage.vue?vue&type=style&index=0&id=5db647f4&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db647f4"]])

export default __exports__